const baseUrl = '/languages';

class LanguagesService {
    constructor() {
    }
    getAllLanguages() {
        return new Promise((resolve, reject) => ApiClient.get(baseUrl, {}).then((response) => {
            if (response.status !== 200) {reject()}
            resolve(response.data.data)
        }).catch((err) => reject(err)));
    }
}
export default new LanguagesService()